import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const Flex = styled(Box)(() => ({
  display: 'flex',
}));

export default Flex;
